const { CONFIG } = require('src/config-global');

export const logos = {
  light: {
    single: `${CONFIG.assetsDir}/logo/logo-single-dark.svg`,
    full: `${CONFIG.assetsDir}/logo/logo-full-dark.svg`,
  },
  dark: {
    single: `${CONFIG.assetsDir}/logo/logo-single-light.svg`,
    full: `${CONFIG.assetsDir}/logo/logo-full-light.svg`,
  },
};
